import PropTypes from 'prop-types';
import { forbidExtraProps } from 'airbnb-prop-types';

import { Navigate } from 'react-router';

import { connect } from 'react-redux';

import valuesOf from 'lodash/fp/values';

import * as checkoutSteps from '../constants/checkoutSteps';

import CheckoutForm from '../Containers/CheckoutForm';

import addOriginParam from 'utils/addOriginParam';
import { Elements } from 'utils/stripeUtils';

import * as checkoutCartSelectors from 'dux/checkoutCart/selectors';

import { useCheckoutCategory } from '../hooks/useCheckoutCategory';

const CheckoutScene = ({ cartIsInCheckout, params, step }) => {
  const checkoutCategory = useCheckoutCategory();

  return cartIsInCheckout ? (
    <Elements
      options={{
        fonts: [
          {
            family: 'Simplon Norm',
            src: 'url(/fonts/SimplonNorm-Regular-WebS.woff)',
          },
        ],
      }}
    >
      <CheckoutForm params={params} step={step} />
    </Elements>
  ) : (
    <Navigate replace to={addOriginParam(params)(`/checkout/${checkoutCategory}`)} />
  );
};

CheckoutScene.propTypes = forbidExtraProps({
  cartIsInCheckout: PropTypes.bool.isRequired,
  params: PropTypes.shape({
    has: PropTypes.func.isRequired,
    get: PropTypes.func.isRequired,
  }).isRequired,
  step: PropTypes.oneOf(valuesOf(checkoutSteps)).isRequired,
});

export default connect(
  state => ({
    cartIsInCheckout: checkoutCartSelectors.getIsInCheckout(state),
  }),
  {}
)(CheckoutScene);
